<!DOCTYPE html
  PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="it" style="height: auto;">

<head id="Head1">
  <!-- INIZIO META TAG PER IDENTIFICAZIONE E MOTORI DI RICERCA -->
  <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1" />
  <title>
    Telefoni e indirizzi - Regione Emilia-Romagna
  </title>
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="description" content="Telefoni e indirizzi" />
  <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/bootstrap/v3.3.7/css/bootstrap.min.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/designer-italia-legacy.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/designer-italia-styleguide.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/build.css" />
  <link rel="stylesheet" href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/er.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/styles.css" />
  <link rel="stylesheet" href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/Site.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/css/all.css" />
  <link rel="shortcut icon" type="image/x-icon" href="https://www.regione.emilia-romagna.it/favicon.ico" />

  <script defer
    src="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/js/all.js"></script>
  <script defer
    src="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/js/v4-shims.js">
  </script>
</head>
<body class="t-Pac c-hideFocus enhanced">
  <div id="visual-portal-wrapper">


    <ul class="Skiplinks js-fr-bypasslinks u-hiddenPrint">
      <li><a href="#main">Vai al Contenuto</a></li>
      <li><a class="js-fr-offcanvas-open" href="#menu" aria-controls="menu" aria-label="accedi al menu"
          title="accedi al menu">Vai alla navigazione del sito</a></li>
    </ul>

    <header class="Header  u-hiddenPrint">
      <div class="Header-banner ">
        <div class="Header-owner Headroom-hideme ">
          <!--a href="http://www.governo.it/"><span>Governo Italiano</span></a-->
          <!-- <div id="link-eng">
            <a href="http://www.regione.emilia-romagna.it/en">english site</a>
          </div> -->
        </div>
      </div>
      <div class="Header-navbar ">
        <div class="u-layout-wide Grid Grid--alignMiddle u-layoutCenter">
          <div class="Header-logo Grid-cell" aria-hidden="true">
            <a href="http://www.regione.emilia-romagna.it" tabindex="-1">
              <img src="https://wwwservizitest.regione.emilia-romagna.it/includes/TemplatesER/img/logo-rer.png"
                alt="Vai alla Home page - Logo Regione Emilia-Romagna">
            </a>
          </div>
          <div class="Header-title Grid-cell">
            <h1 class="Header-titleLink">
              <a href="http://www.regione.emilia-romagna.it">
                <span>Regione Emilia-Romagna</span>
                <span class="subtitle"></span>
              </a>
            </h1>
          </div>
          <div class="Header-toggle Grid-cell">
            <a class="Hamburger-toggleContainer js-fr-offcanvas-open u-nojsDisplayInlineBlock u-lg-hidden u-md-hidden navbar-toggle"
              data-toggle="collapse" data-target=".navbar-collapse" href="#menu" aria-controls="menu"
              aria-label="accedi al menu" title="accedi al menu">
              <span class="Hamburger-toggle" role="presentation"></span>
              <span class="Header-toggleText" role="presentation">Menu</span>
            </a>
          </div>

        </div>
      </div>
      <!-- Header-navbar -->

    </header>
    <div class="navbar navbar-collapse collapse" id="menu">
      <div class="u-layout-wide u-layoutCenter">
        <div class="navbar-collapse collapse ">
        </div>
      </div>
    </div>
  </div>
</body>

</html>
